// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1KOV4","itemTitle":"ClientEmergencyInfo_itemTitle__OPXJa","itemText":"ClientEmergencyInfo_itemText__5McP1"};